import { getBuildByPatchInfo } from 'web/data/core-data'
import { BuildData, Fight, FightEvent, FightPlayer, FightSegment, RosterPlayer, SpecRole, Spell, SpellAssignment } from 'web/data/models'
import { assertDefined } from './utils'

export function sortFightEvents(a: FightEvent, b: FightEvent) {
    if (a.offset === b.offset) {

        if (a.userCreated !== b.userCreated) {
            return a.userCreated ? 1 : -1
        }

        const aName = a.name ?? ""
        const bName = b.name ?? ""

        return aName.localeCompare(bName)
    }

    return a.offset - b.offset
}

export function sortSegments(a: FightSegment, b: FightSegment) {
    return a.offset - b.offset
}

export function sortPlayers(a: RosterPlayer, b: RosterPlayer) {
    const buildData = getBuildByPatchInfo(a.patchInfo)

    const aSpec = buildData.Spec(a.specId)
    const bSpec = buildData.Spec(b.specId)

    if (aSpec.role !== bSpec.role) {
        const roleOridnalMap = {
            [SpecRole.Healer]: 0,
            [SpecRole.Tank]: 1,
            [SpecRole.Ranged]: 2,
            [SpecRole.Melee]: 3,
        }

        return roleOridnalMap[aSpec.role] - roleOridnalMap[bSpec.role]
    }

    if (aSpec.id === bSpec.id) {
        return a.name.localeCompare(b.name)
    }

    return aSpec.id.localeCompare(bSpec.id)
}

export function sortFights(a: Fight, b: Fight) {
    return a.createdAt.localeCompare(b.createdAt)
}

export function sortSpells(a: Spell, b: Spell) {
    if (a.game_id != null && b.game_id != null) {
        return a.game_id - b.game_id
    }

    return a.name.localeCompare(b.name)
}

export function sortSpellAssignments(buildData: BuildData, fightPlayers: FightPlayer[], a: SpellAssignment, b: SpellAssignment) {
    const playerA = fightPlayers.find(p => p.id === a.playerId)
    const playerB = fightPlayers.find(p => p.id === b.playerId)

    assertDefined(playerA)
    assertDefined(playerB)

    const playerOrder = sortPlayers(playerA, playerB)

    if (playerOrder !== 0) {
        return playerOrder
    }

    const spellA = buildData.Spell(a.spellId)
    const spellB = buildData.Spell(b.spellId)

    return sortSpells(spellA, spellB)
}
